import { Formik } from "formik";
import React, { useEffect, useState, useCallback } from "react";
import * as Yup from "yup";
import LocationSearchInput from "../../components/GooglePlacesComponent/PlaceLocationAutoComplete";
import FromCityLocationSearchInput from "../../components/GooglePlacesComponent/FromCityLocationAutoComplete";
import ToCityLocationSearchInput from "../../components/GooglePlacesComponent/ToCityLocationAutoComplete";
import NumberInputWithPopup from "../../components/Inputs/NumberInputWithPopup";
import DatePicker from "react-datepicker";
import addDays from "date-fns/addDays";
import setHours from "date-fns/setHours";
import newbanner from "../../assets/newbanner.jpg";
import mobileMockup from "../../assets/App Promo@6x.png";
import safetyMockup from "../../assets/Safety@4x.png";
import qualityCars from "../../assets/qualitycars.png";
import lowerPrice from "../../assets/lowerprice.png";
import roadsideAssistance from "../../assets/roadsideassistance.png";
import programPartner from "../../assets/programpartner.png";
import localExpertise from "../../assets/expertise.png";
import business from "../../assets/business.svg";
import customer from "../../assets/customer.svg";
import revenue from "../../assets/revenue.svg";
import facebook from "../../assets/facebookicon.svg";
import twitter from "../../assets/twitter.svg";
import instagram from "../../assets/instagram.svg";
import linkedIn from "../../assets/linkedin.svg";
import calendar from "../../assets/calender.png";
import route from "../../assets/route.png"
import route1 from "../../assets/Mobile - Steps@2x.png";
import appPromo1 from "../../assets/App promo without icons@2x.png";
import appPromo2 from "../../assets/App promo 2@2x.png";
import ArrowImage from "../../assets/ArrowImage.png";
import downArrow from "../../assets/Down Arrow White@4x.png";
import { toast, Toaster } from "react-hot-toast";
import RegularButton from "../../components/Buttons/RegularButton";
import { useDispatch, useSelector } from "react-redux";
import { useAppSelector } from "../../redux/app/hooks";
import { FaSearch, FaTimesCircle } from "react-icons/fa";
import { useSaveCustomerFeedbackMutation, useGetAllCustomerFeedbackMutation, } from '../../redux/services/feedbackApi';
import {
  getIsLoggedInData,
  getLocation,
  setCurrentAddressData,
  setCurrentLocationData,
  setFromLocation,
  setLocationData,
  setTimeZone,
  setToLocation,
  setTripDetails,
  setTypeName,
} from "../../redux/slices/navSlice";
import QRCode from "../../assets/borderQR.png";
import google from "../../assets/googleplay.png";
import apple from "../../assets/apple.png";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Virtual, Navigation, Pagination } from "swiper";
import { TextField } from "@mui/material";
import Badge from "@mui/material/Badge";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Select, MenuItem } from "@mui/material";
import { BsGraphUpArrow } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import { last4Character } from "../../redux/services/utility";
import { useSendEmailLinkMutation } from "../../redux/services/emailApi";
import MuiAlert from "../MuiAlert/MuiAlert";
import Loading from "../commons/Loading";
import { Box, Tooltip } from "@mui/material";
import { useFindBlogBySearchMutation } from "../../redux/services/blogsApi";
import { BiDollarCircle } from "react-icons/bi";
import Header from "../../components/Header/Header";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import Footer from "../../components/Footer/Footer";
import { useSaveServiceProviderDetailMutation } from "../../redux/services/serviceProviderApi";
import { useGetAllParkingSpaceLocationByLatLongAndCityMutation } from "../../redux/services/parkingsApi";
import { useGetAllCitiesMutation } from "../../redux/services/cityApi";
import {
  getUserData,
  isNavigation,
  setIsNavigation,
} from "../../redux/slices/authSlice";
import {
  useGetCityDataMutation,
  useGetDataMutation,
} from "../../redux/services/HomeApi";
import { setEnumData } from "../../redux/slices/enumSlice";
import { useGetEnumDataMutation } from "../../redux/services/enumApi";
import {
  getAddressComponent,
  placeAddresCompoponent,
} from "../../redux/services/utility";
import { selectCustomerData, setCustomer } from "../../redux/slices/customerSlice";
import { useGetParkingTypeDataMutation } from "../../redux/services/parkingTypeApi";
import { timezones } from "./timezones";
import moment from 'moment';
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";

SwiperCore.use([Virtual, Navigation, Pagination]);

{/**interface ValidationContext {
  cities: { name: string }[];
}

const checkInOutSchema = Yup.object().shape({
  tripType: Yup.string().required('Trip type is required'),
  fromCity: Yup.string()
  .required('From city is required')
  .test('is-city-available', function (value: any) {
    const context = this.options.context as ValidationContext | undefined;

    if (!context || !context.cities) {
      return true; 
    }

    const { cities } = context;

    if (!value) return true; 

    const city = value.split(',')[0]?.trim().toLowerCase(); 
    const cityExists = cities.some((c) => c.name?.toLowerCase() === city);

    if (!cityExists) {
      return this.createError({
        path: 'fromCity',
        message: `We are unavailable in ${city}.`,
      });
    }

    return true;
  }),
  toCity: Yup.string().required('To city is required'),
  checkIn: Yup.date()
    .required('Check-in date is required'),
  checkOut: Yup.date()
    .required('Check-out date is required'),
  peopleCount: Yup.number()
    .required('Number of guests is required')
    .min(1, 'At least one guest is required'),
  luggageCount: Yup.number()
    .required('Number of luggage is required')
    .min(0, 'Luggage cannot be negative'),
});   */}

type Option = {
  label: string;
  value: string;
};

const options: Option[] = [
  { label: "Option 1", value: "option1" },
  { label: "Option 2", value: "option2" },
  { label: "Option 3", value: "option3" },
];

const becomeAPartnerSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s.-]+$/, { message: "Name must be alphabetic" })
    .trim(),
  businessName: Yup.string()
    .required("Business name is required")
    .matches(/^[a-zA-Z\s.-]+$/, { message: "Business Name must be alphabetic" })
    .trim(),
  contactNumber: Yup.string()
    .required("Contact number is required")
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "Contact number must be 10 digits")
    .max(10, "Contact number must be 10 digits")
    .trim(),
  emailId: Yup.string().email().required("Email is required").trim(),
});

const sendEmailSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required").trim(),
});

function HomePage() {
  const navigate = useNavigate();
  const location: any = useLocation();
  const getLatLng: any = useAppSelector(getLocation);
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(new Date(new Date().getTime() + 30 * 60 * 1000)) as any;
  const [endDate, setEndDate] = useState(new Date(startDate.getTime() + 2 * 60 * 60 * 1000)) as any;
  const [fromAddress, setFromAddress] = useState<any | null>();
  const [toAddress, setToAddress] = useState<any | null>();
  const [address, setAddress] = useState<any | null>();
  const [selectedOption, setSelectedOption] = useState<string>("");
  console.log(selectedOption, "selectedOption");
  const [selectedTripOption, setSelectedTripOption] = useState() as any;
  console.log(selectedTripOption, "selectedTripOption"); const [getTripTypeData, tripTypeResponse] = useGetParkingTypeDataMutation();
  const [tripTypeData, setTripTypeData] = useState([]) as any;
  const [spotsNearby, setSpotsNearby]: any = useState([]);
  const [data, setData]: any = useState([]);
  const [currentAddress, setCurrentAddress] = useState<null | any>();
  const [offset, setOffset] = useState(4);
  const [places, setPlaces]: any = useState([]);
  const [getCityData, cityResponse]: any = useGetCityDataMutation();
  const getlogedIn = useAppSelector(getIsLoggedInData);
  const userData = useSelector(getUserData);
  const [getData, parkingTypeResponse] = useGetDataMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;
  const customerData = useAppSelector(selectCustomerData);
  const [isNavigatedToUpdateProfile, setIsNavigatedToUpdateProfile] =
    useState(false);
  const isNavigationEditProfile = useAppSelector(isNavigation);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [rowParPage, setRowParPage] = useState(5);
  const [blogOffset, setBlogOffset] = useState(3);
  const [findBlogBySearch, findBlogBySearchResponse] =
    useFindBlogBySearchMutation();
  const [sendEmailLink, sendEmailLinkResponse] = useSendEmailLinkMutation();
  const [statusCodes, setStatusCodes] = useState({ type: "", code: "" }) as any;
  const [email, setEmail] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [blog, setBlog] = useState([]) as any;
  const [saveServiceProviderDetail, saveResponse] =
    useSaveServiceProviderDetailMutation();
  const [selectedTZOptions, setSelectedTZOptions] = useState() as any;
  const [cities, setCities] = useState<any[]>([]);
  const [popularCities, setPopularCities] = useState<any[]>([]);
  const [cityPage, setCityPage] = useState(0);
  const [hasMoreCities, setHasMoreCities] = useState(true);
  const [feedbacks, setFeedbacks] = useState<any[]>([]);
  const [searchCity, setSearchCity] = useState<any[]>([]);
  //console.log("Set search City:",setSearchCity);
  const token: string = currentUser?.jwtToken;
  const customerId = currentUser?.customerId;
  const [getAllCities] = useGetAllCitiesMutation();
  const [getAllCustomerFeedback, getAllCustomerFeedbackResponse] = useGetAllCustomerFeedbackMutation();
  const [findByCustomerId, findByCustomerIdResponse] = useFindCustomerDetailByIdMutation();

  useEffect(() => {
    getAllCustomerFeedback({
      token: token,
      payload: {
        offset: 10,
        page: 0,
        status: true,
      },
    }).then((response) => {
      if ("data" in response) {
        setFeedbacks(response.data.data);
        console.log("Feedbacks:", response.data.data);
      } else if ("error" in response) {
        console.error("Failed to fetch cities:", response.error);
      }
    });
  }, [getAllCustomerFeedback]);


  useEffect(() => {
    if (userData) {
      findByCustomerId({ token: token, id: customerId });
    }
  }, [userData]);

  useEffect(() => {
    if (findByCustomerIdResponse.isSuccess) {
      dispatch(setCustomer(findByCustomerIdResponse.data));
      localStorage.setItem(
        "customerDetail",
        JSON.stringify(findByCustomerIdResponse.data)
      );
    }

  }, [findByCustomerIdResponse.isSuccess, findByCustomerIdResponse.isError]);

  useEffect(() => {
    if (searchCity) {
      //console.log("CITY IN API:",searchCity);
      getAllCities({
        token: token,
        payload: {
          offset: 5,
          page: 0,
          status: true,
          searchValue: searchCity,
        },
      }).then((response) => {
        if ("data" in response) {
          setCities(response.data.data);
        } else if ("error" in response) {
          console.error("Failed to fetch cities:", response.error);
        }
      });
    }
  }, [searchCity, getAllCities]);

  const loadCities = useCallback(
    async (page: any) => {
      try {
        const response = await getAllCities({
          token: token,
          payload: {
            offset: 5,
            page: page,
            status: true,
          },
        });

        if ('data' in response) {
          const cities = response.data.data;

          setPopularCities((prevCities) => (page === 0 ? cities : [...prevCities, ...cities]));

          if (cities.length < 5) {
            setHasMoreCities(false);
          }
        } else if ('error' in response) {
          console.error('Failed to fetch cities:', response.error);
        }
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    },
    [getAllCities, token]
  );

  useEffect(() => {
    if (cityPage === 0) {
      loadCities(0);
    }
  }, []);

  const handleEndReach = () => {
    if (hasMoreCities) {
      setCityPage((prevPage) => prevPage + 1);

      if (cityPage > 0) {
        loadCities(cityPage);
      }
    }
  };
  // const locationFromChange = (item: any) => {
  //   console.log(item, "item")
  //   dispatch(setFromLocation(item))
  //   setFromAddress(item);
  // };
  // const locationToChange = (item: any) => {
  //   let payload = {
  //     fromLocation: fromAddress,
  //     toLocation: item
  //   }
  //   dispatch(setLocationData(payload == null ? {} : payload));
  //   setToAddress(item);
  //   dispatch(setToLocation(item))
  //   setAddress(payload)
  // };

  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [airports, setAirports]: any = useState([]);
  const [
    getAllParkingSpaceLocationByLatLongAndCity,
    getAllParkingSpaceLocationByLatLongAndCityResponse,
  ] = useGetAllParkingSpaceLocationByLatLongAndCityMutation();

  const [getAllParkingAirport, getAllParkingAirportResponse] =
    useGetAllParkingSpaceLocationByLatLongAndCityMutation();

  const [checkOutDate, setCheckOutDate] = useState(endDate);

  const handleSubmitForm = async (values: any, action: any) => {
    const tripPayload = {
      address,
      checkOut:
        selectedOption === "OutStation One Way" || selectedOption === "Airport Drop"
          ? null
          : selectedOption === "OutStation Round Trip"
            ? endDate
            : selectedOption === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(values.packageType.match(/^(\d+)\s*hrs/)?.[1] || "2", 10),
                  "hours"
                )
                .toDate()
              : null,
      checkIn: startDate,
      luggageCount: values.luggageCount,
      peopleCount: values.peopleCount,
      TripType: selectedTripOption,
      selectedTZOptions: selectedTZOptions,
      packageType: values.packageType,
    };
    localStorage.removeItem("bookingDetails");
    localStorage.removeItem("passengerDetail");
    localStorage.removeItem("tripDetails");

    if (selectedTripOption?.typeName == "Hourly Rental") {
      dispatch(setToLocation(""));
    }
    // Store in Redux
    // dispatch(setTripDetails(tripPayload));
    localStorage.removeItem("tripDetails");
    localStorage.setItem("tripDetails", JSON.stringify(tripPayload));
    navigate("/profile/find-vehicle");
    // navigate("/profile/find-parking-slot", {
    //   state: {
    //     address: address,
    //     checkOut: selectedOption === "OutStation One Way" || selectedOption === "Airport Drop"
    //       ? null
    //       : selectedOption === "OutStation Round Trip"
    //         ? endDate
    //         : selectedOption === "Hourly Rental" && startDate
    //           ? moment(startDate)
    //             .add(
    //               parseInt(values.packageType.match(/^(\d+)\s*hrs/)?.[1] || "2", 10),
    //               "hours"
    //             )
    //             .toDate()
    //           : null,
    //     checkIn: startDate,
    //     luggageCount: values.luggageCount,
    //     peopleCount: values.peopleCount,
    //     TripType: selectedTripOption,
    //     selectedTZOptions: selectedTZOptions,
    //     packageType: values.packageType,
    //   },
    // });

  };
  useEffect(() => {
    getTripTypeData({
      payload: {
        offset: rowParPage,
        pageNumber: page,
        sortOrder: order,
        status: true,
      },
    });
  }, [getTripTypeData]);


  useEffect(() => {
    const selectedTimeZone = timezones.filter(
      (item: any) => item.value === Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    setSelectedTZOptions(selectedTimeZone);
    dispatch(setTimeZone(selectedTimeZone));
  }, []);

  useEffect(() => {
    if (tripTypeResponse.isSuccess) {
      setTripTypeData(tripTypeResponse.data.data);
      handleChangeType(tripTypeResponse.data.data[0])
    }
  }, [tripTypeResponse.isSuccess]);



  const handleChangeType = (value: any) => {
    setSelectedTripOption(value)
    setSelectedOption(value.typeName);
    dispatch(setTypeName(value.typeName))
  };

  const checkIn = new Date(new Date().getTime() + 30 * 60 * 1000);
  const checkOut = new Date(checkIn.getTime() + 2 * 60 * 60 * 1000);


  const [initialValue, setInitialValue] = useState({
    tripType: selectedOption,
    fromCity: '',
    toCity: '',
    checkIn: startDate,
    checkOut: endDate,
    peopleCount: 1,
    luggageCount: 0,
    packageType: '',
  });


  const validationSchema = Yup.object().shape({
    tripType: Yup.string().required('Trip type is required'),

    fromCity: Yup.string()
      .required('From city is required')
      .test('is-valid-city', function (value, context) {
        const city = context.parent.fromCityLocality?.trim().toLowerCase();

        console.log("Locality from validation:", city);

        const cityExists = cities.some((cityItem) => {
          if (typeof cityItem.name !== 'string') {
            console.warn('Non-string value found in cities array:', cityItem.name);
            return false;
          }
          return cityItem.name.toLowerCase() === city;
        });

        return cityExists ? true : this.createError({ message: `We are unavailable in ${city}.` });
      }),

    toCity: Yup.string().when("tripType", {
      is: (tripType: any) => tripType !== "Hourly Rental",
      then: (schema) => schema.required("To city is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    checkIn: Yup.date().required('Check-in date is required'),

    checkOut: Yup.date().when("tripType", {
      is: (tripType: any) => tripType === "OutStation Round Trip",
      then: (schema) => schema.required("Check-out date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    packageType: Yup.string().when("tripType", {
      is: (tripType: any) => tripType === "Hourly Rental",
      then: (schema) => schema.required("Package type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  useEffect(() => {
    setInitialValue((prevValues) => ({
      ...prevValues,
      tripType: selectedOption,
    }));

  }, [selectedOption,]);

  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    return currentDate.getTime() < selectedDate.getTime();
  };

  function getAddressFromCoordinates(latitude: any, longitude: any) {
    return new Promise((resolve, reject) => {
      fetch(
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        latitude +
        "," +
        longitude +
        "&location_type=ROOFTOP&result_type=street_address" +
        "&key=" +
        googleApiKey
      )
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.status === "OK") {
            resolve(responseJson?.results?.[0]?.formatted_address);
            dispatch(
              setCurrentAddressData(
                responseJson?.results?.[0]?.address_components
              )
            );
            setCurrentAddress(responseJson?.results?.[0]?.address_components);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
    if (enumResponse.isError) {
    }
  }, [enumResponse.isSuccess || enumResponse.isError]);

  const [packageType, setPackageType] = useState<any[]>([]);
  const [mapKey, setMapKey] = useState([]);
  const [googleApiKey, setGoogleApiKey] = useState<string>('');
  const [selectedPackage, setSelectedPackage] = useState<string>("");
  useEffect(() => {
    if (enumResponse?.data) {
      const packageTypes = enumResponse.data["PACKAGE_TYPE"] || [];
      const mapKeys = enumResponse.data["MAP_KEY"] || [];
      setPackageType(packageTypes);
      setMapKey(mapKeys);
    }
  }, [enumResponse]);

  useEffect(() => {
    mapKey.map((map: any) => {
      if (map.type === 'MAP_KEY') {
        setGoogleApiKey(map.displayValue);
      }
    });
  }, []);


  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      const currentCoords = {
        lat:
          location?.state?.address != undefined
            ? location?.state?.address?.lat
            : position.coords.latitude,
        lng:
          location?.state?.address != undefined
            ? location?.state?.address?.lng
            : position.coords.longitude,
      };
      dispatch(setCurrentLocationData(currentCoords));
      getAddressFromCoordinates(currentCoords.lat, currentCoords.lng);
    });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("user") !== null) {
      localStorage.setItem("isLoggedIn", "true");
    } else {
      localStorage.setItem("isLoggedIn", "false");
    }
    getData({
      payload: {
        offset: 5,
        page: 0,
      },
    });
  }, []);

  useEffect(() => {
    if (parkingTypeResponse.isSuccess) {
      let userData: any = parkingTypeResponse.data;
      setData(userData.data);
    }
  }, [parkingTypeResponse.isSuccess]);

  // useEffect(() => {
  //   if (
  //     customerData &&
  //     isNavigatedToUpdateProfile === false &&
  //     isNavigationEditProfile === false
  //   ) {
  //     if (
  //       customerData?.email === null ||
  //       customerData?.phoneNo === null ||
  //       customerData?.name === null ||
  //       customerData?.country === null ||
  //       customerData?.addressLine1 === null ||
  //       customerData?.state === null ||
  //       customerData?.city === null ||
  //       customerData?.pinCode === null
  //     ) {
  //       navigate("/profile/account");
  //       setIsNavigatedToUpdateProfile(true);
  //       dispatch(setIsNavigation(true));
  //     }
  //   }
  // }, [customerData, isNavigatedToUpdateProfile, isNavigationEditProfile]);

  useEffect(() => {
    if (currentAddress) {
      getCityData({
        payload: {
          searchValue: getAddressComponent(
            currentAddress,
            placeAddresCompoponent.COUNTRY
          ),
          offset: 5,
          page: 0,
          status: true,
        },
      });
    }
  }, [currentAddress]);

  useEffect(() => {
    if (cityResponse.isSuccess) {
      let userCityDataForResponse: any = cityResponse.data;
      setPlaces(userCityDataForResponse.data);
    }
  }, [cityResponse.isSuccess]);

  // useEffect(() => {
  //   if (getAllParkingSpaceLocationByLatLongAndCityResponse.isSuccess) {
  //     let spotsNearbyData: any =
  //       getAllParkingSpaceLocationByLatLongAndCityResponse.data;
  //     setSpotsNearby(spotsNearbyData.data);
  //   }
  // }, [getAllParkingSpaceLocationByLatLongAndCityResponse.isSuccess]);

  useEffect(() => {
    if (parkingTypeResponse.isSuccess) {
      let userData: any = parkingTypeResponse.data;
      setData(userData.data);
    }
  }, [parkingTypeResponse.isSuccess]);

  // useEffect(() => {
  //   getAllParkingSpaceLocationByLatLongAndCity({
  //     payload: {
  //       offset: offset,
  //       page: page,
  //       lat: getLatLng?.lat,
  //       lng: getLatLng?.lng,
  //       customerId: getlogedIn ? userData?.customerId : 0,
  //       orderBy: "asc",
  //       columnName: "id",
  //     },
  //   });
  // }, [getLatLng]);

  useEffect(() => {
    getEnumData({});
  }, []);

  // useEffect(() => {
  //   if (selectedTripOption) {
  //     getAllParkingAirport({
  //       payload: {
  //         offset: offset,
  //         page: page,
  //         lat: getLatLng?.lat,
  //         lng: getLatLng?.lng,
  //         customerId: getlogedIn ? userData?.customerId : 0,
  //         columnName: "id",
  //         orderBy: "asc",
  //         checkInTime: startDate ? startDate : location?.state?.checkIn,
  //         checkOutTime: endDate ? endDate : location?.state?.checkOut,
  //         parkingTypeId: [selectedTripOption?.id],
  //       },
  //     });
  //   }

  // }, [selectedTripOption]);

  useEffect(() => {
    if (getAllParkingAirportResponse.isSuccess) {
      let getAirportSpacesData: any = getAllParkingAirportResponse.data;
      setAirports(getAirportSpacesData.data);
    }
  }, [getAllParkingAirportResponse.isSuccess]);

  useEffect(() => {
    if (cityResponse.isSuccess) {
      let userCityDataForResponse: any = cityResponse.data;
      setPlaces(userCityDataForResponse.data);
    }
  }, [cityResponse.isSuccess]);

  // useEffect(() => {
  //   if (getAllParkingSpaceLocationByLatLongAndCityResponse.isSuccess) {
  //     let spotsNearbyData: any =
  //       getAllParkingSpaceLocationByLatLongAndCityResponse.data;
  //     setSpotsNearby(spotsNearbyData.data);
  //   }
  // }, [getAllParkingSpaceLocationByLatLongAndCityResponse.isSuccess]);

  useEffect(() => {
    if (currentAddress) {
      getCityData({
        payload: {
          searchValue: getAddressComponent(
            currentAddress,
            placeAddresCompoponent.COUNTRY
          ),
          offset: 5,
          page: 0,
          status: true,
        },
      });
    }
  }, [currentAddress]);

  useEffect(() => {
    findBlogBySearch({
      payload: {
        offset: blogOffset,
        page: page,
        orderBy: "asc",
        status: true,
      },
    });
  }, [findBlogBySearch]);

  useEffect(() => {
    if (findBlogBySearchResponse.isSuccess) {
      let userFindBlogBySearchResponse: any = findBlogBySearchResponse.data;
      setBlog(userFindBlogBySearchResponse.data);
    }
  }, [findBlogBySearchResponse.isSuccess]);

  const [formValues, setFormValues] = useState({
    name: "",
    contactNumber: "",
    emailId: "",
    businessName: "",
    exemptPayeeCode: "",
    exemptionFromFATCAReportingCode: "",
    address: "",
    city: "",
    state: "",
    country: "",
    ZIPCode: "",
    listAccountNumber: "",
    socialSecurityNumber: "",
    employerIdentificationNumber: "",
    taxClassification: "",
    other: "",
    companyTypeList: "",
    fromCity: "",
    toCity: "",
    luggageCount: "",
    peopleCount: "",
  });

  const saveServiceProviderDataToServer = async (values: any, action: any) => {
    await saveServiceProviderDetail({
      payload: {
        address: values.address,
        businessName: values.businessName.trim(),
        city: values.city.trim(),
        commission: "",
        companyTypeList: values.companyTypeList,
        contactNumber: values.contactNumber,
        country: values.country.trim(),
        einNumber: values.employerIdentificationNumber,
        emailId: values.emailId.trim(),
        exemptFatca: 0,
        filePath: "",
        gstNo: "",
        llcTaxType: values.taxClassification,
        name: values.name.trim(),
        other: values.other,
        password: "",
        payeeCode: 0,
        listAccountNumber: values.primaryAccountNo,
        socialSecNumber: values.socialSecurityNumber,
        state: values.state.trim(),
        status: values.status,
        tierType: "",
        vatNo: "",
        zip: values.ZIPCode,
        requestFrom: "PWA",
        vendorAlias:
          values.businessName + "-" + last4Character(values.contactNumber),
      },
    });
    action.resetForm();
  };

  useEffect(() => {
    if (saveResponse.isSuccess) {
      setStatusCodes({ type: "success", code: "PARTNER_SUCCESSFUL" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (saveResponse.isError) {
      let errorData: any = saveResponse.error;
      let errorMessage = errorData.error || errorData.data.serviceErrors[0].msg;
      if (errorMessage === "User already exists") {
        setStatusCodes({ type: "error", code: "USERNAME_EXIST_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      } else {
        setStatusCodes({ type: "error", code: "CONSENT_FORM_ERROR" });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      }
    }
  }, [saveResponse.isSuccess, saveResponse.isError]);

  /**const [benefits, setBenefits] = React.useState([
    {
      id: 0,
      icon: <img src={Group146647} alt="icon" className="text-[68px]" />,
      title: "No more coins",
      subTitle:
        "You will never need to worry about having the right change again, just download the app to pay.",
    },
    {
      id: 1,
      icon: <img src={parking1} alt="icon" className="text-[68px]" />,
      title: "Park with just few clicks",
      subTitle:
        "You will never need to worry about having the right change again, just download the app to pay. ",
    },
    {
      id: 2,
      icon: <img src={lowestprice2} alt="icon" className="text-[68px]" />,
      title: "Lesser pricing",
      subTitle:
        "You will never need to worry about having the right change again, just download the app to pay.",
    },
  ]);

  const badgeStyle = {
    "& .MuiBadge-badge": {
      fontSize: "20px",
      width: 50,
      height: 45,
      borderRadius: "50%",
      backgroundColor: "#37BDE2",
    },
  };  

  const [howItWorks, sethowItWorks] = React.useState([
    {
      id: 0,
      icon: <Badge badgeContent={1} color="primary" sx={badgeStyle}></Badge>,
      title: "Park",
      image: <img src={Group146644} alt="icon" className="text-[68px] h-50 " />,
    },
    {
      id: 1,
      icon: <Badge badgeContent={2} color="primary" sx={badgeStyle}></Badge>,
      title: "Pay",
      image: (
        <img src={parkingDetail} alt="icon" className="text-[68px] h-50" />
      ),
    },
    {
      id: 2,
      icon: <Badge badgeContent={3} color="primary" sx={badgeStyle}></Badge>,
      title: "Done",
      image: <img src={Group146645} alt="icon" className="text-[68px] h-50" />,
    },
  ]);  */

  const handleSendLink = (values: any) => {
    sendEmailLink({
      emailId: values.email,
    });
  };
  useEffect(() => {
    const success: any = sendEmailLinkResponse?.error;
    if (success?.data == "OK") {
      setStatusCodes({ type: "success", code: "EMAIL_SENT_SUCCESS" });
      setEmail(" ");
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (
      success?.data !== undefined &&
      success?.data !== null &&
      success?.data !== "OK"
    ) {
      setStatusCodes({ type: "error", code: "EMAIL_SENT_FAILURE" });
      setEmail(" ");
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [sendEmailLinkResponse?.error]);

  const [isVisible, setIsVisible] = useState(false);

  const handleToggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (feedbacks.length > 0) {
      const heights = feedbacks.map(feedback => {
        const textLength = feedback?.comments ? feedback?.comments.length : 0;
        return Math.min(400, 150 + textLength * 0.5);
      });
      setMaxHeight(Math.max(...heights));
    }
  }, [feedbacks]);

  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [isPackageTypeDropdownOpen, setIsPackageTypeDropdownOpen] = useState(false);

  const selectedTrip = tripTypeData.find((opt: any) => opt.typeName === selectedOption);

  return (
    <div className="overscroll-x-none">
      <div className="h-[75px] z-20 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
      </div>
      <div className=" ">
        {enumResponse.isLoading ||
          sendEmailLinkResponse.isLoading ||
          parkingTypeResponse.isLoading ||
          // getAllParkingSpaceLocationByLatLongAndCityResponse.isLoading ||
          // getAllParkingAirportResponse.isLoading ||
          cityResponse.isLoading ? (
          <Loading />
        ) : null}
        <div className=" " id="/">
          <div
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div
              className="container"
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="md:h-[800px] h-[950px] xl:w-[1440px] lg:w-[1024px] md:w-[768px] lg:mt-5 md:mt-10 mt-12 w-full relative overflow-hidden">
                <div
                  className="md:h-[800px] h-[950px] w-full relative bg-cover bg-no-repeat"
                  style={{ backgroundImage: `url(${newbanner})`, backgroundPosition: "right center" }}
                >
                  <div className="absolute inset-0 bg-opacity-50 bg-black flex flex-row items-center text-center grid grid-cols-1 md:grid-cols-5">
                    <div className="flex flex-col justify-center md:col-span-3 w-full">
                      <div className="w-full absolute top-0 transform mt-4">
                        <Toaster position="top-center" reverseOrder={false} toastOptions={{ style: { width: "100%" } }} />
                      </div>
                      <div className="flex flex-row pl-[10px] lg:hidden md:hidden">
                        <div className="flex flex-col mt-10">
                          <h1 className="text-white text-left text-[25px] font-bold mb-4 lg:hidden md:hidden">
                            Discover endless routes with <span className="text-[#ED1C24]">reliable rides</span>
                          </h1>
                        </div>
                        <div className="flex flex-col">
                          <img src={appPromo2} alt="Mobile App" className="w-[500px] md:w-[600px]" onClick={() => document.getElementById('downloadQR')?.scrollIntoView({ behavior: 'smooth' })} />
                        </div>
                      </div>
                      <div className="flex flex-col mr-[10px] justify center lg:hidden md:hidden">
                        <h2 className="text-white text-center font-bold text-[20px]">
                          DOWNLOAD APP
                        </h2>
                        <div className="flex flex-row gap-2 justify-center">
                          <a
                            href="https://apps.apple.com/us/app/spotfinder-india/id6448868015"
                            target="_blank"
                            rel="noreferrer"
                            className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat mb-3"
                            style={{ backgroundImage: `url(${apple})` }}
                          ></a>
                          <a
                            href="https://play.google.com/store/apps/details?id=com.spotfindermobileappin&hl=en-IN"
                            target="_blank"
                            rel="noreferrer"
                            className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat"
                            style={{ backgroundImage: `url(${google})` }}
                          ></a>
                        </div>
                      </div>
                      <h1 className="text-white text-3xl md:text-5xl lg:text-[50px] font-bold mb-4 hidden md:block">
                        Discover endless routes with <span className="text-[#ED1C24]">reliable rides</span>
                      </h1>
                      <Formik
                        enableReinitialize
                        initialValues={initialValue}
                        onSubmit={handleSubmitForm}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={false}
                      >
                        {({
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          values,
                          touched,
                          errors,
                          setErrors,
                          setFieldError,
                          setFieldValue,
                          setFieldTouched,
                        }) => {

                          const clearFromInput = () => {
                            console.log("clearInput function called");

                            setFieldValue("fromCity", "");
                            setFieldValue("fromCityLocality", "");
                            setFromAddress(null);
                            dispatch(setFromLocation(null));
                            setAddress("");
                            setLocationData({});

                            setFieldTouched("fromCity", false);
                            setErrors({
                              ...errors,
                              fromCity: undefined,
                            });
                          };

                          const clearToInput = () => {
                            console.log("clearToInput function called");

                            setFieldValue("toCity", "");
                            setFieldValue("toCityLocality", "");
                            setToAddress(null);
                            dispatch(setToLocation(null));
                            setAddress("");
                            setLocationData({});

                          };
                          return (
                            <div className="p-[20px] md:px-[50px] lg:px-[50px] xl:px-[100px] 2xl:px-[100px]">
                              <div className="bg-white w-full md:w-full lg:w-full lg:m-5 rounded-[40px] shadow-lg p-4 lg:px-4">
                                <form onSubmit={handleSubmit}>
                                  {/**<div className="pb-2 overflow-x-auto md:overflow-visible whitespace-nowrap md:whitespace-normal flex flex-nowrap md:flex-wrap md:flex-row gap-4 items-center justify-start md:justify-center">
    {tripTypeData &&
      tripTypeData.map((option: any) => (
        <label
          key={option.id}
          className={`relative flex lg:flex-row md:flex-col items-center gap-1 px-4 py-2 cursor-pointer rounded-full border w-full sm:w-[30%] md:w-[40%] lg:w-[23%] transition-all ${
            selectedOption === option.typeName
              ? "bg-red-600 text-white border-red-600"
              : "bg-gray-700 text-white border-gray-700"
          } whitespace-normal break-words`}
        >
          <input
            type="radio"
            name="typeName"
            value={option.typeName}
            checked={selectedOption === option.typeName}
            onChange={() => {
              setFieldValue("pickupAddress", option.typeName);
              handleChangeType(option);
            }}
            className="hidden"
          />
          <img src={option.imageUrl} alt={option.typeName} className="w-8 h-8 sm:w-10 sm:h-10" />
          <div className="flex flex-wrap">
            <span className="text-md sm:text-md font-medium break-words w-full text-center leading-tight">
              {option.typeName}
            </span>
            {selectedOption === option.typeName && (
              <div className="absolute bottom-[-4px] left-1/2 transform -translate-x-1/2 w-3/4 h-[2px] bg-white"></div>
            )}
          </div>
        </label>
      ))}
  </div> */}

                                  <div className="pb-2">
                                    {/* Dropdown for medium and small screens */}
                                    {/**<div className="lg:hidden relative">
                                      <div
                                        className="relative flex items-center gap-3 bg-[#ED1C24] rounded-full px-4 py-2 cursor-pointer"
                                        onClick={() => setIsDropDownOpen(!isDropDownOpen)}
                                      >
                                        {selectedTrip && (
                                          <img src={selectedTrip.imageUrl} alt={selectedOption} className="w-6 h-6" />
                                        )}

                                        <span className="text-white">{selectedOption || "Select Trip Type"}</span>

                                        <span className="text-white ml-auto">&#9662;</span>
                                      </div>

                                      {isDropDownOpen && (
                                        <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg mt-1 shadow-lg z-10">
                                          {tripTypeData.map((option: any) => (
                                            <div
                                              key={option.id}
                                              className="flex items-center gap-3 px-4 py-2 cursor-pointer bg-[#58595B] rounded-3xl m-1 text-white font-medium hover:bg-[#ED1C24]"
                                              onClick={() => {
                                                setFieldValue("pickupAddress", option.typeName);
                                                handleChangeType(option);
                                                setIsDropDownOpen(false);
                                              }}
                                            >
                                              <img src={option.imageUrl} alt={option.typeName} className="w-6 h-6" />

                                              <span>{option.typeName}</span>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div> */}

                                    <div className="lg:hidden relative">
                                      {/* Dropdown Button */}
                                      <div
                                        className="relative flex items-center gap-3 bg-[#ED1C24] rounded-full px-4 py-2 cursor-pointer"
                                        onClick={() => setIsDropDownOpen(!isDropDownOpen)}
                                      >
                                        {/* Selected Option Image */}
                                        {selectedTrip && (
                                          <img src={selectedTrip.imageUrl} alt={selectedOption} className="w-6 h-6" />
                                        )}

                                        {/* Selected Option Text */}
                                        <span className="text-white">{selectedOption || "Select Trip Type"}</span>

                                        {/* Dropdown Arrow */}
                                        <img src={downArrow} alt="Dropdown Arrow" className="w-4 h-4 ml-auto" />
                                      </div>

                                      {/* Dropdown List */}
                                      {isDropDownOpen && (
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-[90%] bg-white border border-gray-300 rounded-b-3xl shadow-lg z-10">
                                          {tripTypeData.map((option: any) => (
                                            <div
                                              key={option.id}
                                              className="flex items-center gap-3 px-4 py-2 cursor-pointer bg-[#58595B] rounded-3xl m-1 text-white font-medium hover:bg-[#ED1C24]"
                                              onClick={() => {
                                                setFieldValue("pickupAddress", option.typeName);
                                                handleChangeType(option);
                                                setIsDropDownOpen(false);
                                              }}
                                            >
                                              {/* Option Image */}
                                              <img src={option.imageUrl} alt={option.typeName} className={`${option.typeName === "OutStation Round Trip" || option.typeName === "Airport Drop" || option.typeName === "OutStation One Way" ? "w-8 h-8" : "w-6 h-6"
                                                }`} />

                                              {/* Option Text */}
                                              <span>{option.typeName}</span>
                                            </div>
                                          ))}
                                          {/* Close Dropdown Arrow */}
                                          <div
                                            className="flex justify-center items-center py-2 cursor-pointer"
                                            onClick={() => setIsDropDownOpen(false)}
                                          >
                                            <img src={ArrowImage} alt="Close Dropdown" className="w-5 h-5 rotate-180" />
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    {/* Labels in row for large screens */}
                                    <div className="md:hidden hidden lg:flex lg:overflow-visible lg:whitespace-normal lg:flex-wrap lg:flex-row lg:gap-3 gap-4 items-center justify-start">
                                      {tripTypeData &&
                                        tripTypeData.map((option: any) => (
                                          <label
                                            key={option.id}
                                            className={`relative flex flex-row items-center gap-1 ${option.typeName === "Hourly Rental" || option.typeName === "Airport Drop" ? "px-4" : "px-2"
                                              } py-1 cursor-pointer rounded-full border w-full sm:w-[30%] md:w-[40%] lg:w-[23%] transition-all ${selectedOption === option.typeName
                                                ? "bg-[#ED1C24] text-white border-[#ED1C24]"
                                                : "bg-[#58595B] text-white border-[#58595B]"
                                              } whitespace-normal break-words`}
                                          >
                                            <input
                                              type="radio"
                                              name="typeName"
                                              value={option.typeName}
                                              checked={selectedOption === option.typeName}
                                              onChange={() => {
                                                setFieldValue("pickupAddress", option.typeName);
                                                handleChangeType(option);
                                              }}
                                              className="hidden"
                                            />
                                            <img src={option.imageUrl} alt={option.typeName} className={`${option.typeName === "OutStation Round Trip" || option.typeName === "Airport Drop" || option.typeName === "OutStation One Way" ? "sm:w-8 sm:h-8" : "sm:w-6 sm:h-6"
                                              } `} />
                                            <div className="flex flex-wrap">
                                              <span className="lg:text-xs md:text-sm text-sm font-bold break-words w-full text-center leading-tight">
                                                {option.typeName}
                                              </span>
                                              {/**selectedOption === option.typeName && (
                    <div className="absolute bottom-[-6px] left-1/2 transform -translate-x-1/2 w-3/4 h-[2px] bg-[#ED1C24]"></div>
                  )*/}
                                            </div>
                                          </label>
                                        ))}
                                    </div>
                                  </div>

                                  <div className="flex flex-col lg:flex-row items-center justify-center w-full gap-4 lg:gap-6 mt-4">
                                    <div className="flex flex-col w-full lg:w-[75%]">
                                      <div className="flex flex-col lg:flex-row w-full px-2 gap-4 lg:gap-2 lg:mb-0 mb-4">
                                        <div className="rounded-[5px] w-full">
                                          <FromCityLocationSearchInput
                                            locationDetail={(item: any) => {
                                              let payload = {
                                                fromLocation: item,
                                                toLocation: toAddress,
                                              };
                                              console.log("locationDetail item:", item.locality);
                                              dispatch(setLocationData(payload == null ? {} : payload));
                                              setFromAddress(item);
                                              dispatch(setFromLocation(item));
                                              setAddress(payload);

                                              setFieldValue("fromCity", item.formatted_address);
                                              setFieldValue("fromCityLocality", item.locality);
                                              setSearchCity(item.locality);
                                              setFieldTouched("fromCity", false);
                                              console.log("Updated fromCity value:", item.formatted_address);
                                            }}
                                            value={values.fromCity}
                                            //onBlur={(e) => {
                                            // handleBlur(e);
                                            // setFieldTouched("fromCity", true);
                                            //}}
                                            clearInput={clearFromInput}
                                            tripType={values.tripType}
                                          />
                                          <div className="text-[#ED1C24] text-xs lg:min-h-[20px]">
                                            {touched.fromCity && errors.fromCity && errors.fromCity}
                                          </div>
                                        </div>
                                        <div className="flex flex-col w-full lg:w-[50%]">
                                          <p className="font-semibold text-gray-800 lg:text-sm md:text-sm text-md text-left uppercase mb-1 ml-2">DATE & TIME</p>
                                          <div className="bg-gray-200 rounded-full px-3 flex items-center w-full">
                                            <img src={calendar} alt="Date" className="w-3 h-3 text-[#ED1C24] mr-2" />
                                            <DatePicker
                                              selected={startDate}
                                              minDate={new Date()}
                                              maxDate={addDays(new Date(), 365)}
                                              onChange={(date: any) => {
                                                setStartDate(date);
                                                setEndDate(new Date(date.getTime() + 2 * 60 * 60 * 1000));
                                                setFieldValue("checkIn", date);
                                              }}
                                              disabledKeyboardNavigation
                                              filterTime={filterPassedTime}
                                              selectsStart
                                              showTimeSelect
                                              startDate={startDate}
                                              endDate={endDate}
                                              timeIntervals={60}
                                              dateFormat="dd/MM/yyyy h:mm aa"
                                              placeholderText="Date/Time"
                                              className="bg-transparent border-0 focus:outline-none flex-grow text-gray-500 text-xs"
                                              onBlur={handleBlur("checkIn")}
                                            />
                                          </div>

                                          <div className="text-[#ED1C24] text-xs lg:min-h-[20px]">
                                            {touched.checkIn && errors.checkIn &&
                                              <span>{typeof errors.checkIn === "string" ? errors.checkIn : String(errors.checkIn)}</span>}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="w-full mb-4 border-t-2 border-[#ED1C24] border-dashed"></div>

                                      <div className="flex flex-col lg:flex-row w-full px-2 gap-4 lg:gap-2">
                                        {values.tripType !== "Hourly Rental" && (
                                          <div className={` rounded-[5px]  ${values.tripType !== 'OutStation Round Trip'
                                            ? "lg:w-[50%]"
                                            : "w-full"
                                            }`}>
                                            <ToCityLocationSearchInput
                                              locationDetail={(item) => {
                                                let payload = {
                                                  fromLocation: fromAddress,
                                                  toLocation: item,
                                                };
                                                dispatch(setLocationData(payload || {}));
                                                setToAddress(item);
                                                dispatch(setToLocation(item));
                                                setAddress(payload);
                                                setFieldValue("toCity", item.formatted_address);
                                              }}
                                              value={values.toCity}
                                              searchOptions={{ types: selectedOption === "Airport Drop" ? ["airport"] : [] }}
                                              clearInput={clearToInput}
                                              tripType={values.tripType}
                                            />
                                            <div className="text-[#ED1C24] text-xs lg:min-h-[20px]">
                                              {touched.toCity && errors.toCity && errors.toCity}
                                            </div>
                                          </div>
                                        )}
                                        {values.tripType === "OutStation Round Trip" && (
                                          <div className="flex flex-col w-full lg:w-[50%]">
                                            {/* Title */}
                                            <p className="font-semibold text-left text-gray-800 lg:text-sm md:text-sm text-sm uppercase mb-1 ml-2">{values.tripType === "OutStation Round Trip" ? `RETURN DATE` : `DATE & TIME`}</p>

                                            {/* Input Container */}
                                            <div className="bg-gray-200 rounded-full px-3 flex items-center w-full">
                                              {/* Calendar Icon */}
                                              <img src={calendar} alt="Date" className="w-3 h-3 text-[#ED1C24] mr-2" />

                                              {/* DatePicker */}
                                              <DatePicker
                                                selected={endDate}
                                                onChange={(date) => {
                                                  setEndDate(date);
                                                  setFieldValue("checkOut", date);
                                                }}
                                                selectsEnd
                                                showTimeSelect
                                                dateFormat="dd/MM/yyyy h:mm aa"
                                                minDate={startDate}
                                                maxDate={addDays(new Date(), 365)}
                                                timeIntervals={60}
                                                className="bg-transparent border-0 focus:outline-none flex-grow text-gray-500 text-xs"
                                              />
                                            </div>
                                            <div className="text-[#ED1C24] text-xs lg:min-h-[20px]">
                                              {touched.checkOut && errors.checkOut && (
                                                <span>{typeof errors.checkOut === "string" ? errors.checkOut : String(errors.checkOut)}</span>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                        {values.tripType === "Hourly Rental" && (
                                          /** <div className="flex flex-col w-full lg:w-[50%]">
                                            <p className="font-semibold text-gray-800 text-md text-left lg:text-sm md:text-sm text-sm capitalize mb-1 ml-2">Package Type</p>
                                            <div className="bg-gray-200 border border-gray-300 rounded-full py-1 px-3 flex items-center w-full">
                                              <select
                                                className="bg-gray-200 w-full outline-none border-none focus:ring-0 text-gray-500 text-xs appearance-none"
                                                value={values.packageType}
                                                onChange={(e) => {
                                                  setFieldValue("packageType", e.target.value);
                                                  setFieldTouched("packageType", false);
                                                }}
                                              >
                                                <option value="">Select Package</option>
                                                {packageType.map((option, index) => (
                                                  <option key={index} value={option.displayValue} className="px-3 hover:bg-[#ED1C24]">{option.displayValue}</option>
                                                ))}
                                              </select>
                                              <span className="text-gray-600 text-sm ml-auto">&#9662;</span>
                                            </div>
                                            <div className="text-[#ED1C24] text-xs">
                                            {errors.packageType && touched.packageType && errors.packageType }
                                            </div>
                                          </div> */
                                          <div className="flex flex-col w-full lg:w-[50%] relative">

                                            <p className="font-semibold text-gray-800 text-md text-left lg:text-sm md:text-sm text-sm capitalize mb-1 ml-2">
                                              Package Type
                                            </p>


                                            <div
                                              className="bg-gray-200 rounded-full flex items-center w-full px-3 py-1 cursor-pointer relative"
                                              onClick={() => setIsPackageTypeDropdownOpen((prev) => !prev)}
                                            >
                                              <span className="text-gray-500 text-xs w-full text-left">
                                                {values.packageType || "Select Package"}
                                              </span>

                                              <img src={ArrowImage} alt="Dropdown Arrow" className="w-3 h-3 ml-auto" />
                                            </div>


                                            {isPackageTypeDropdownOpen && (
                                              <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-b-3xl shadow-lg z-[999] max-h-[200px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
                                                {packageType && packageType.length > 0 ? (
                                                  packageType.map((option, index) => (
                                                    <div
                                                      key={index}
                                                      className="flex  texgt-xs items-center gap-3 px-4 py-1 m-1 cursor-pointer bg-[#58595B] rounded-3xl text-white font-medium hover:bg-[#ED1C24]"
                                                      onClick={() => {
                                                        setFieldValue("packageType", option.displayValue);
                                                        setFieldTouched("packageType", false);
                                                        setIsPackageTypeDropdownOpen(false);
                                                      }}
                                                    >
                                                      <span className="text-xs">{option.displayValue}</span>
                                                    </div>
                                                  ))
                                                ) : (
                                                  <div className="px-4 py-2 text-gray-500">No options available</div>
                                                )}


                                                <div
                                                  className="flex justify-center items-center py-2 cursor-pointer"
                                                  onClick={() => setIsPackageTypeDropdownOpen(false)}
                                                >
                                                  <img src={ArrowImage} alt="Close Dropdown" className="w-3 h-3 rotate-180" />
                                                </div>
                                              </div>
                                            )}

                                            <div className="text-[#ED1C24] text-xs">
                                              {errors.packageType && touched.packageType && errors.packageType}
                                            </div>
                                          </div>

                                        )}
                                      </div>
                                    </div>

                                    <div className="flex items-center justify-center w-full lg:w-[25%]">
                                      <div
                                        className={`flex items-center lg:w-[120px] lg:h-[120px] md:w-[110px] md:h-[110px] w-[90px] h-[90px] justify-center rounded-full p-1 transition-all ${startDate >= endDate
                                          ? "bg-gray-300"
                                          : "bg-[#ED1C24] hover:bg-red-500"
                                          }`}
                                      >
                                        <button
                                          type="submit"
                                          disabled={startDate >= endDate}
                                          onClick={() => handleSubmit()}
                                          className={`relative flex flex-col items-center lg:w-[110px] lg:h-[110px] md:w-[100px] md:h-[100px] w-[80px] h-[80px] justify-center text-white font-semibold text-lg transition-all whitespace-nowrap ${startDate >= endDate
                                            ? "bg-gray-300 hover:bg-gray-300 text-black cursor-not-allowed"
                                            : "bg-[#ED1C24] hover:bg-red-500 cursor-pointer"
                                            }`}
                                          style={{
                                            borderRadius: "50%",
                                            border: "5px solid white",
                                            textAlign: "center",
                                          }}
                                        >
                                          <span className="text-sm lg:text-xl md:text-lg">ENGINE</span>
                                          <span className="font-bold text-sm lg:text-xl md:text-lg">START</span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          );
                        }}
                      </Formik>
                    </div>
                    <div className="flex justify-center md:col-span-2 w-full h-full hidden md:flex">
                      <img src={mobileMockup} alt="Mobile App" className="w-[500px] lg:w-[100%] lg:h-[100%] h-[500px] mt-[195px] lg:mt-[0px] " onClick={() => document.getElementById('downloadQR')?.scrollIntoView({ behavior: 'smooth' })} />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>


          {/** Why Choose Us */}
          <section className="bg-white mt-5 px-4 sm:px-8  hidden md:flex">
            <div className="w-full bg-[#F9F4EF] rounded-[100px] shadow-lg p-14">
              {/* Heading */}
              <h2 className="mt-4 lg:text-[40px] lg:text-[40px] md:text-[36px] text-[34px] font-bold text-[#ED1C24] text-left">
                Why Choose Us?
              </h2>

              {/* Content Grid */}
              <div className="grid md:grid-cols-1 gap-10 mt-10">
                {/* Range of Quality Cars */}
                <div className="flex items-start justify-center gap-6">
                  <div className="w-[40%] ml-auto">
                    <img
                      src={qualityCars}
                      alt="Quality Cars"
                      className="w-[300px] h-[150px]"
                    />
                  </div>
                  <div className="w-[48%] flex flex-col text-left border-l-[5px] border-l-[#ED1C24]">

                    <div className="flex items-center ">
                      <h3 className="lg:text-[30px] md:text-[25px] text-[20px] ml-3 font-bold text-[#58595B]">
                        Range of Quality Cars
                      </h3>
                    </div>
                    <div>
                      <p className="text-black-600 lg:text-lg md:text-md text-sm mr-10 mt-4 ml-4">
                        From compact cars to spacious SUVs, we have the perfect vehicle for your needs.
                      </p>
                    </div>

                  </div>
                </div>

                {/* Lower Prices */}
                <div className="flex items-start justify-center gap-6">
                  <div className="w-[48%] flex flex-col text-right border-r-[5px] border-r-[#ED1C24]">

                    <div className="flex items-center justify-end pr-4">
                      <h3 className="lg:text-[30px] md:text-[30px] text-[30px] font-bold text-[#58595B]">
                        Lower Prices
                      </h3>
                    </div>

                    {/* Description Row */}
                    <div>
                      <p className="text-black-600 lg:text-lg md:text-md text-sm ml-10 mt-4 mr-4">
                        We're committed to offering you lower prices on a diverse fleet of quality vehicles.
                      </p>
                    </div>

                  </div>

                  <div className="w-[40%] ml-auto">
                    <img
                      src={lowerPrice}
                      alt="Lower Prices"
                      className="w-[200px] h-[200px]"
                    />
                  </div>
                </div>

                {/* 24/7 Roadside Assistance */}
                <div className="flex items-start justify-center gap-6">
                  <div className="w-[40%] ml-auto">
                    <img
                      src={roadsideAssistance}
                      alt="Roadside Assistance"
                      className="w-[300px] h-[150px]"
                    />
                  </div>

                  <div className="w-[48%] flex flex-col text-left border-l-[5px] border-l-[#ED1C24]">

                    {/* Heading Row with Red Left Border */}
                    <div className="flex items-center">
                      <h3 className="lg:text-[35px] md:text-[30px] ml-3 text-[30px] font-bold text-[#58595B]">
                        24/7 Roadside Assistance
                      </h3>
                    </div>

                    {/* Description Row */}
                    <div>
                      <p className="text-black-600 lg:text-lg md:text-md text-sm mr-10 mt-4 ml-4">
                        Enjoy peace of mind with our comprehensive roadside assistance program.
                      </p>
                    </div>

                  </div>
                </div>

                {/* Local Expertise */}
                <div className="flex items-start justify-center gap-6">
                  {/* Text Column (45%) - Comes First */}
                  <div className="w-[48%] flex flex-col text-right border-r-[5px] border-r-[#ED1C24]">

                    {/* Heading Row with Right Border */}
                    <div className="flex items-center  justify-end pr-4">
                      <h3 className="lg:text-[35px] md:text-[30px] text-[30px] font-bold text-[#58595B]">
                        Local Expertise
                      </h3>
                    </div>

                    {/* Description Row */}
                    <div>
                      <p className="text-black-600 lg:text-lg md:text-md text-sm ml-10 mt-4 mr-4">
                        As a local car rental company, we have in-depth knowledge of the area and can
                        provide valuable travel tips.
                      </p>
                    </div>

                  </div>

                  {/* Image Column (40%) - Comes Second */}
                  <div className="w-[40%] ml-auto">
                    <img
                      src={localExpertise}
                      alt="Local Expertise"
                      className="w-[200px] h-[200px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/** Why Choose Us (Mobile View) */}
          <section className="bg-white py-5 px-5 sm:px-8 lg:px-16 flex justify-center lg:hidden md:hidden">
            <div className="max-w-4xl bg-[#F9F4EF] rounded-[50px] shadow-lg py-10 px-5 text-center">
              {/* Heading */}
              <h2 className="text-[25px] md:text-[50px] lg:text-[65px] font-bold text-[#ED1C24] mb-8">
                Why Choose Us?
              </h2>

              {/* Content Grid */}
              <div className="flex flex-col items-center gap-12">
                {/* Range of Quality Cars */}
                <div className="flex flex-col items-center text-center">
                  <img src={qualityCars} alt="Quality Cars" className="w-[300px] h-[150px]" />
                  <h3 className="text-[20px] font-bold text-[#58595B] mt-4">Range of Quality Cars</h3>
                  <p className="text-black-600 text-md mt-2 max-w-lg">
                    From compact cars to spacious SUVs, we have the perfect vehicle for your needs.
                  </p>
                </div>

                {/* Lower Prices */}
                <div className="flex flex-col items-center text-center">
                  <img src={lowerPrice} alt="Lower Prices" className="w-[200px] h-[200px]" />
                  <h3 className="text-[20px] font-bold text-[#58595B] mt-4">Lower Prices</h3>
                  <p className="text-black-600 text-md mt-2 max-w-lg">
                    We're committed to offering you lower prices on a diverse fleet of quality vehicles.
                  </p>
                </div>

                {/* 24/7 Roadside Assistance */}
                <div className="flex flex-col items-center text-center">
                  <img src={roadsideAssistance} alt="Roadside Assistance" className="w-[300px] h-[150px]" />
                  <h3 className="text-[20px] font-bold text-[#58595B] mt-4">24/7 Roadside Assistance</h3>
                  <p className="text-black-600 text-md mt-2 max-w-lg">
                    Enjoy peace of mind with our comprehensive roadside assistance program.
                  </p>
                </div>

                {/* Local Expertise */}
                <div className="flex flex-col items-center text-center">
                  <img src={localExpertise} alt="Local Expertise" className="w-[200px] h-[200px]" />
                  <h3 className="text-[20px] font-bold text-[#58595B] mt-4">Local Expertise</h3>
                  <p className="text-black-600 text-md mt-2 max-w-lg">
                    As a local car rental company, we have in-depth knowledge of the area and can provide valuable travel tips.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/** Safety is Priority */}
          <section className="bg-white py-5 px-4 sm:px-8 lg:px-16 hidden md:flex">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">

              {/* Left Content Section */}
              <div className="w-full md:w-1/2 ">
                <h2 className="text-[#ED1C24] lg:text-[50px] md:text-[40px] text-[25px] font-bold leading-tight">
                  Safety is our top priority
                </h2>

                <ul className="mt-10 space-y-6">
                  {/* Point 1 */}
                  <li className="flex items-start">
                    <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                    <div>
                      <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                        Rigorous Vehicle Maintenance
                      </h3>
                      <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                        Our fleet undergoes strict, certified inspections ensuring top
                        mechanical safety for every rental.
                      </p>
                    </div>
                  </li>

                  {/* Point 2 */}
                  <li className="flex items-start">
                    <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                    <div>
                      <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                        Thorough Sanitization
                      </h3>
                      <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                        We prioritize your health with comprehensive cleaning and
                        disinfection of all vehicle surfaces.
                      </p>
                    </div>
                  </li>

                  {/* Point 3 */}
                  <li className="flex items-start">
                    <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                    <div>
                      <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                        24/7 Emergency Support
                      </h3>
                      <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                        Enjoy peace of mind with round-the-clock roadside assistance and
                        immediate emergency help.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Right Image Section */}
              <div className="w-full md:w-1/2 flex justify-center p-12">
                <img
                  src={safetyMockup}
                  alt="Safety Illustration"
                  className="w-full lg:w-[500px]"
                />
              </div>

            </div>
          </section>

          {/** Safety is Priority (Mobile View) */}
          <section className="bg-white py-5 px-4 sm:px-8 lg:px-16 lg:hidden md:hidden">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">

              <h2 className="text-center text-[#ED1C24] lg:text-[65px] md:text-[30px] text-[25px] font-bold leading-tight">
                Safety is our top priority
              </h2>
              <div className="flex flex-col">
                <div className="w-full md:w-1/2 w-1/2 flex justify-center px-5">
                  <img
                    src={safetyMockup}
                    alt="Safety Illustration"
                    className="w-full lg:w-[500px]"
                  />
                </div>
                <div className="w-full md:w-1/2 w-1/2 justify-center">
                  <ul className="mt-10 space-y-6">
                    {/* Point 1 */}
                    <li className="flex items-start">
                      <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                      <div>
                        <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                          Rigorous Vehicle Maintenance
                        </h3>
                        <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                          Our fleet undergoes strict, certified inspections ensuring top
                          mechanical safety for every rental.
                        </p>
                      </div>
                    </li>

                    {/* Point 2 */}
                    <li className="flex items-start">
                      <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                      <div>
                        <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                          Thorough Sanitization
                        </h3>
                        <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                          We prioritize your health with comprehensive cleaning and
                          disinfection of all vehicle surfaces.
                        </p>
                      </div>
                    </li>

                    {/* Point 3 */}
                    <li className="flex items-start">
                      <span className="text-[#ED1C24] text-2xl font-bold mr-2">•</span>
                      <div>
                        <h3 className="lg:text-lg md:text-md text-sm font-bold text-gray-800">
                          24/7 Emergency Support
                        </h3>
                        <p className="text-black lg:text-sm md:text-sm text-sm sm:text-base">
                          Enjoy peace of mind with round-the-clock roadside assistance and
                          immediate emergency help.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>

            </div>
          </section>

          {/** How Does it Work */}
          <div id="how-it-works">
            <section className="bg-white py-5 px-4 sm:px-8 justify-center hidden md:flex">
              <div className="w-full bg-[#F9F4EF] rounded-[100px] shadow-lg p-14 relative">
                {/* Heading */}
                <h2 className="mx-2 lg:text-[40px] md:text-[40px] text-[35px] font-bold text-[#ED1C24] text-left">
                  How does it work?
                </h2>

                {/* Route Image */}
                <div className="relative flex justify-center my-12">
                  <img src={route} alt="Process Route" className="w-full max-w-3xl" />

                  {/* Steps */}
                  {/* Step 1 - Request a Ride */}
                  <div className="absolute lg:top-[-20%] md:top-[-20%] top-[-25%] left-[-1%] text-left w-[50%] md:w-[50%] lg:w-[40%]">
                    <p className="font-bold text-black text-sm md:text-md lg:text-lg">
                      Enter Trip Details
                    </p>
                    <p className="text-gray-600 lg:text-lg md:text-md text-sm w-full break-words">
                      Choose locations, date, and time to get started.
                    </p>
                  </div>

                  {/* Step 2 - See Driver Offers */}
                  <div className="absolute lg:top-[-30%] md:top-[-30%] top-[-30%] md:right-[0%] right-[10%] text-right text-left w-[50%] md:w-[50%] lg:w-[35%]">
                    <p className="font-bold text-black text-sm md:text-md lg:text-lg">Explore Car Options</p>
                    <p className="text-gray-600 lg:text-lg md:text-md text-sm w-full break-words">Browse through available cars based on your preferences.</p>
                  </div>

                  {/* Step 3 - Choose Your Driver */}
                  <div className="absolute lg:bottom-[-10%] md:bottom-[-10%] bottom-[-15%] left-[5%] text-left w-[50%] md:w-[50%] lg:w-[35%]">
                    <p className="font-bold text-black text-sm md:text-md lg:text-lg">Select & Review</p>
                    <p className="text-gray-600 lg:text-lg md:text-md text-sm w-full break-words">Pick your preferred car</p>
                  </div>

                  {/* Step 4 - Connect & Confirm */}
                  <div className="absolute lg:bottom-[-20%] md:bottom-[-25%] bottom-[-25%] right-[5%] text-right w-[50%] md:w-[50%] lg:w-[35%]">
                    <p className="font-bold text-black text-sm md:text-md lg:text-lg">Confirm & Pay</p>
                    <p className="text-gray-600 lg:text-lg md:text-md text-sm w-full break-words">Enter required details and complete the booking securely</p>
                  </div>
                </div>
              </div>
            </section>

            {/** How Does it Work (Mobile View) */}
            <section className="bg-white py-5 px-4 lg:hidden md:hidden">
              <div className="max-w-6xl mx-auto bg-[#F9F4EF] rounded-[80px] shadow-lg pb-10 pt-5 px-5 relative">
                {/* Heading */}
                <h2 className="text-[25px] text-center font-bold text-[#ED1C24] text-left">
                  How does it work?
                </h2>

                {/* Route Image */}
                <div className="relative flex justify-center my-12">
                  <img src={route1} alt="Process Route" className="w-[60%] max-[320px]:w-[40%] max-[375px]:w-[50%]" />

                  {/* Steps */}
                  {/* Step 1 - Request a Ride */}
                  <div className="absolute max-[320px]:top-[-35%] max-[375px]:top-[-30%] top-[-20%] max-[320px]:left-[-5%] left-[0%] text-left whitespace-normal break-words w-[50%]">
                    <p className="font-bold text-black text-xs ">Enter Trip Details</p>
                    <p className="text-gray-600 text-xs">Choose locations, date, and time to get started.</p>
                  </div>

                  {/* Step 2 - See Driver Offers */}
                  <div className="absolute max-[320px]:top-[-20%] max-[375px]:top-[-10%] top-[-5%] right-[0%] text-right whitespace-normal break-words w-[50%]">
                    <p className="font-bold text-black text-xs ">Explore Car Options</p>
                    <p className="text-gray-600 text-xs">Browse through available cars based on your preferences.</p>
                  </div>

                  {/* Step 3 - Choose Your Driver */}
                  <div className="absolute max-[320px]:bottom-[-8%] max-[375px]:bottom-[-5%] bottom-[0%] left-[0%] text-left whitespace-normal break-words w-[50%]">
                    <p className="font-bold text-black text-xs">Select & Review</p>
                    <p className="text-gray-600 text-xs">Pick your preferred car</p>
                  </div>

                  {/* Step 4 - Connect & Confirm */}
                  <div className="absolute max-[320px]:bottom-[-40%] max-[375px]:bottom-[-30%] bottom-[-25%] max-[320px]:right-[-3%] right-[5%] text-right whitespace-normal break-words w-[50%]">
                    <p className="font-bold text-black text-xs ">Confirm & Pay</p>
                    <p className="text-gray-600 text-xs">Enter required details and complete the booking securely</p>
                  </div>
                </div>
              </div>
            </section>
          </div>


          <section className="bg-white py-5 px-4 sm:px-8 lg:px-20" id="become-a-partner">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center px-6">

              {/* Left Content Section */}
              <div className="w-full md:w-1/2">
                <h2 className="text-[#ED1C24] lg:text-[50px] md:text-[40px] text-[25px] font-bold leading-tight hidden md:flex">
                  Our Partner Program
                </h2>
                <h2 className="text-center text-[#ED1C24] lg:text-[70px] md:text-[50px] text-[25px] font-bold leading-tight lg:hidden md:hidden">
                  Our Partner Program
                </h2>
                <div className="w-full flex justify-center pt-8 lg:hidden md:hidden">
                  <img
                    src={programPartner}
                    alt="Partner Program Illustration"
                    className="w-full max-w-[500px]"
                  />
                </div>
                {/* Features Grid */}
                <div className="grid grid-cols-3 gap-10 items-center mt-6">

                  {/* Feature 1 */}
                  <div className="flex flex-col items-center">
                    <div className="flex justify-center items-center">
                      <img src={business} alt="Grow Business" className="w-24 h-24" />
                    </div>
                    <p className="text-center lg:text-lg md:text-md text-sm font-semibold text-gray-800 mt-3">Grow your Business</p>
                  </div>

                  {/* Feature 2 */}
                  <div className="flex flex-col items-center">
                    <div className="flex justify-center items-center">
                      <img src={customer} alt="Get Customers" className="w-24 h-24" />
                    </div>
                    <p className="text-center lg:text-lg md:text-md text-sm font-semibold text-gray-800 mt-3">Get New Customers</p>
                  </div>

                  {/* Feature 3 */}
                  <div className="flex flex-col items-center">
                    <div className="flex justify-center items-center">
                      <img src={revenue} alt="Increase Revenue" className="w-24 h-24" />
                    </div>
                    <p className="text-center lg:text-lg md:text-md text-sm font-semibold text-gray-800 mt-3">Increase Revenue</p>
                  </div>

                </div>

                {/* Centered Button */}
                <div className="mt-8 flex justify-center">
                  <button className="bg-[#ED1C24] text-white lg:text-2xl md:text-lg text-md font-bold py-3 px-8 w-full max-w-[300px] rounded-full shadow-lg hover:bg-red-700 transition duration-300"
                    onClick={() => {
                      navigate("/become-a-partner");
                    }}>
                    Become a Partner
                  </button>
                </div>
              </div>

              {/* Right Image Section */}
              <div className="w-full md:w-1/2 flex justify-center py-8 hidden md:flex">
                <img
                  src={programPartner}
                  alt="Partner Program Illustration"
                  className="w-full max-w-[500px]"
                />
              </div>

            </div>
          </section>

          {/** Download App */}
          <div id="downloadQR">
            <section className="bg-white lg:pl-16 md:pl-10 md:ml-5 lg:ml-12 mt-10 hidden lg:flex">
              <div className="flex flex-row w-full">
                <div className="flex flex-col w-[60%]">
                  <div className="flex flex-row lg:gap-10 md:gap-5">
                    <div className="flex flex-col">
                      <h2 className="text-[#ED1C24] font-bold lg:text-[50px] md:text-[35px] text-[30px]">
                        DOWNLOAD APP
                      </h2>
                      <div className="flex flex-row w-full justify-center gap-5">
                        <a
                          href="https://apps.apple.com/us/app/spotfinder-india/id6448868015"
                          target="_blank"
                          rel="noreferrer"
                          className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat"
                          style={{ backgroundImage: `url(${apple})` }}
                        ></a>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.spotfindermobileappin&hl=en-IN"
                          target="_blank"
                          rel="noreferrer"
                          className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat"
                          style={{ backgroundImage: `url(${google})` }}
                        ></a>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <img src={QRCode} alt="QR Code" className="lg:w-[200px] md:w-40" />
                    </div>
                  </div>
                  <div className="flex flex-row mt-10 gap-5">
                    <div className="flex flex-col lg:w-[40%] md:w-[40%]">
                      <h3 className="text-sm font-bold text-black">CaRental</h3>
                      <p className="mt-2 text-xs">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
                      </p>
                      <h3 className="mt-4 font-bold text-black text-lg">Terms</h3>
                      <a
                        href="https://carrental.rightbraininfotech.in/profile/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black no-underline cursor-pointer block mt-1 text-sm"
                      >
                        Privacy Policy
                      </a>
                      <a
                        href="https://carrental.rightbraininfotech.in/profile/terms-and-condition"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black no-underline cursor-pointer block mt-1 text-sm"
                      >
                        Terms of Service
                      </a>
                      <div className="flex flex-col">
                        <p className="text-sm mt-4 font-bold">Follow Us</p>
                        <div className="flex flex-row mt-3 gap-4">
                          <img src={facebook} alt="Facebook" className="w-8" />
                          <img src={twitter} alt="Twitter" className="w-8" />
                          <img src={linkedIn} alt="LinkedIn" className="w-8" />
                          <img src={instagram} alt="Instagram" className="w-8" />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col lg:w-[30%] md:w-[30%]">
                      <h3 className="text-sm font-bold text-black">Location</h3>
                      <p className="text-xs mt-2">
                        Panchshil Futura, Sr No 133(P), CTS No 4944, Magarpatta, Hadapsar, Pune, Maharashtra 411028
                      </p>
                      <h3 className="mt-4 font-bold text-black">Contact</h3>
                      <p className="text-xs mt-2 font-bold">(020) 4131 2229</p>
                      <h3 className="mt-4 font-bold text-black">Email</h3>
                      <p className="text-xs mt-2 font-bold">contact@carrental.app</p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col w-[40%]">
                  <img src={appPromo1} alt="Mobile App" className="w-[500px] lg:w-[800px] h-[700px]" />
                </div>
              </div>
            </section>

            {/** Download App (Tab & Mobile View) */}
            <section className="bg-white my-5 lg:hidden">
              <div className="flex flex-col">
                <div className="flex flex-row mb-3 justify-center">
                  <h2 className="text-[#ED1C24] text-center font-bold md:text-[40px] text-[30px]">
                    DOWNLOAD APP
                  </h2>
                </div>
                <div className="flex flex-row w-full justify-center">
                  <div className="flex flex-col w-1/2 px-5 md:items-center justify-center">
                    <img src={QRCode} alt="QR Code" className="w-50 md:w-60 mb-3" />
                    <div className="md:justify-center md:pr-0 pr-10">
                      <a
                        href="https://apps.apple.com/us/app/spotfinder-india/id6448868015"
                        target="_blank"
                        rel="noreferrer"
                        className="flex h-12 rounded-lg text-white p-1 w-40 md:w-60 bg-no-repeat mb-3"
                        style={{ backgroundImage: `url(${apple})` }}
                      ></a>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.spotfindermobileappin&hl=en-IN"
                        target="_blank"
                        rel="noreferrer"
                        className="flex h-12 rounded-lg text-white p-1 w-40 md:w-60 bg-no-repeat"
                        style={{ backgroundImage: `url(${google})` }}
                      ></a>
                    </div>
                  </div>
                  <div className="flex flex-col w-1/2">
                    <img src={appPromo1} alt="Mobile App" className="w-[500px]" />
                  </div>
                </div>
                <div className="flex flex-row w-full px-5 mt-5 gap-4">
                  <div className="flex flex-col w-1/2">
                    <h3 className="text-2xl font-bold text-black">CaRental</h3>
                    <p className="mt-2 text-sm">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
                    </p>
                    <h3 className="mt-4 font-bold text-black text-lg">Terms</h3>
                    <a
                      href="https://carrental.rightbraininfotech.in/profile/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-black no-underline cursor-pointer block mt-1 text-sm"
                    >
                      Privacy Policy
                    </a>
                    <a
                      href="https://carrental.rightbraininfotech.in/profile/terms-and-condition"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-black no-underline cursor-pointer block mt-1 text-sm"
                    >
                      Terms of Service
                    </a>

                  </div>
                  <div className="flex flex-col w-1/2">
                    <h3 className="font-bold text-black">Location</h3>
                    <p className="text-sm mt-2">
                      Panchshil Futura, Sr No 133(P), CTS No 4944, Magarpatta, Hadapsar, Pune, Maharashtra 411028
                    </p>
                    <h3 className="mt-4 font-bold text-black">Contact</h3>
                    <p className="text-sm mt-2 font-bold">(020) 4131 2229</p>
                    <h3 className="mt-4 font-bold text-black">Email</h3>
                    <p className="text-xs mt-2">contact@carrental.app</p>
                    <div className="flex flex-row mt-5 gap-1">
                      <p className="text-[10px] text-center">Follow Us</p>
                      <div className="flex flex-row gap-1">
                        <img src={facebook} alt="Facebook" className="md:w-7 w-5" />
                        <img src={twitter} alt="Twitter" className="md:w-7 w-5" />
                        <img src={linkedIn} alt="LinkedIn" className="md:w-7 w-5" />
                        <img src={instagram} alt="Instagram" className="md:w-7 w-5" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </section>
          </div>



          {/**<section className="bg-white py-12 px-4 sm:px-8 lg:px-16 lg:ml-12">

            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 items-center gap-12">
              
              <div className="w-full flex flex-row gap-10">
                <div className="flex flex-col">
                  <h2 className="text-red-600 font-bold lg:text-[60px] md:text-[40px] text-[30px]">
                    DOWNLOAD APP
                  </h2>

                  <div className="mt-6 flex flex-col sm:flex-row items-center gap-6">
                    <div className="flex flex-row">
                      <a
                        href="https://apps.apple.com/us/app/spotfinder-india/id6448868015"
                        target="_blank"
                        rel="noreferrer"
                        className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat"
                        style={{ backgroundImage: `url(${apple})` }}
                      ></a>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.spotfindermobileappin&hl=en-IN"
                        target="_blank"
                        rel="noreferrer"
                        className="flex h-12 rounded-lg text-white p-1 w-40 bg-no-repeat"
                        style={{ backgroundImage: `url(${google})` }}
                      ></a>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col items-center">
                      <img src={QRCode} alt="QR Code" className="w-60" />
                </div>
              </div>

              <div className="w-full flex flex-col items-center">
                <img src={mobileMockup} alt="Mobile App" className="w-full max-w-[400px]" />

                <div className="flex mt-6 gap-4">
                  <img src={facebook} alt="Facebook" className="w-8" />
                  <img src={twitter} alt="Twitter" className="w-8" />
                  <img src={linkedIn} alt="LinkedIn" className="w-8" />
                  <img src={instagram} alt="Instagram" className="w-8" />
                </div>
              </div>

            </div>

            <div className="max-w-7xl mx-auto mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-gray-700">
              
              <div>
                <h3 className="text-2xl font-bold text-black">CaRental</h3>
                <p className="mt-2 text-sm">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
                </p>
                <h3 className="mt-4 font-bold text-black">Terms</h3>
                <p className="text-sm">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-black">Location</h3>
                <p className="text-sm mt-2">
                  Panchshil Futura, Sr No 133(P), CTS No 4944, Magarpatta, Hadapsar, Pune, Maharashtra 411028
                </p>
                <h3 className="mt-4 font-bold text-black">Contact</h3>
                <p className="text-sm mt-2 font-bold">(020) 4131 2229</p>
                <h3 className="mt-4 font-bold text-black">Email</h3>
                <p className="text-sm mt-2">contact@carrental.app</p>
              </div>

            </div>
          </section>   */}

          {/** App QR 
          <div className="relative w-full mt-16">
            <div className="flex flex-col lg:flex-row bg-white rounded-lg mx-4 lg:p-6">

              <div className="flex flex-col items-start text-left lg:w-full m-4 p-4">
                <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-2">
                  Download our free <span className="bg-red-500 text-gray-800">app</span>
                </h1>
                <p className="text-gray-600 text-base lg:text-lg mb-6">
                  It makes ordering more convenient, and you also get notifications of drivers’ offers
                </p>
                <div>
                  {isAlertVisible && (
                    <div>
                      <MuiAlert
                        severity={statusCodes?.type!}
                        messageType={statusCodes?.code!}
                      />
                    </div>
                  )} </div>
                <Formik
                  enableReinitialize
                  validationSchema={sendEmailSchema}
                  initialValues={{ email: "" }}
                  onSubmit={handleSendLink}
                >
                  {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    errors,
                  }) => (
                    <div className="flex flex-col">
                      <div className="flex flex-row">
                        <input
                          placeholder="Enter Your Email"
                          className="md:h-12 h-10 md:w-[230px] w-[150px] border-2 px-2 bg-white text-black-500 justify-center md:text-xl text-[15px] rounded-l-md font-normal"
                          onChange={handleChange}
                          type="email"
                          autoComplete="email"
                          id="email"
                          name="email"
                          onBlur={handleBlur}
                        />
                        <button
                          className="md:h-12 h-10 md:w-[100px] bg-red-500 text-black p-1 md:text-xl text-[15px] w-[100px] font-medium rounded-r-md"
                          onClick={() => handleSubmit()}
                        >
                          Submit
                        </button>
                      </div>
                      {errors.email && touched.email && (
                        <p className="text-white ml-1">
                          {errors.email}
                        </p>
                      )}
                    </div>
                  )}
                </Formik>
                <div className="flex mt-7 w-full flex-row gap-2">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.spotfindermobileappin&hl=en-IN"
                    target="_blank"
                    rel="noreferrer"
                    className="flex h-12 rounded-lg text-white p-1 w-1/2 lg:w-40 bg-no-repeat"
                    style={{ backgroundImage: `url(${google})` }}
                  ></a>
                  <a
                    href="https://apps.apple.com/us/app/spotfinder-india/id6448868015"
                    target="_blank"
                    rel="noreferrer"
                    className="flex h-12 rounded-lg text-white p-1 w-1/2 lg:w-40 bg-no-repeat"
                    style={{ backgroundImage: `url(${apple})` }}
                  ></a>
                </div>
              </div>

              <div className="flex flex-col items-center lg:w-1/2 mt-8 lg:mt-0 bg-gray-100 p-6 rounded-xl shadow-lg m-6 p-6">
                <img
                  src={QRCode}
                  alt="QR Code"
                  className="w-40 h-40 mb-4"
                />
                <p className="text-gray-700 text-center">
                  Scan the QR code to download the new Car Rental India app
                </p>

              </div>
            </div>
          </div> */}
          {/** <div>
            <div>
              {spotsNearby.length !== 0 && getLatLng ? (
                <div className="pt-10 mx-[5%]">
                  <div className="text-center">
                    <h1 className="lg:text-[3rem] md:text[2.5rem] text-[30px] font-medium text-[#2D3748] grid-cols-4 ">
                      Our Spots Nearby!
                    </h1>
                  </div>

                  <div className="mt-5 container w-full">
                    <div className="mt-5 container mx-auto w-full">
                      <div className="lg:flex sm:flex-row justify-center gap-10 items-center mt-5">
                        {getLatLng &&
                          spotsNearby.map((spot: any, index: any) => (
                            <Card
                              sx={{
                                width: "w-full",
                                height: "h-full",
                                borderRadius: "10px",
                                border: "1px solid #e6e6e6",
                                boxShadow: "none",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                cursor: "pointer",
                                marginTop: "8px",
                              }}
                              key={spot.index}
                            >
                              <CardMedia
                                component="img"
                                height="100%"
                                width="100%"
                                sx={{
                                  height: 200,
                                  width: 700,
                                }}
                                image={
                                  spot?.imageList[0]?.filePreSignedUrl !== null
                                    ? spot?.imageList[0]?.filePreSignedUrl
                                    : require("../../assets/blog2.jpg")
                                }
                                alt="parking"
                              />
                              <CardContent
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "100%",
                                  width: "100%",
                                  padding: "0",
                                  margin: "0",
                                  borderRadius: "0",
                                  border: "0",
                                }}
                              >
                                <h2 className="text-[#344054] mx-2 lg:text-[100%] md:text-[1.0rem] text-[0.9rem] font-semibold mt-5">
                                  {spot.name}
                                </h2>
                                <div>
                                  {spot.hourlyRate > 0 && (
                                    <h1 className="font-semibold text-base">
                                      ₹{spot.hourlyRate}/ hour
                                    </h1>
                                  )}
                                  {spot.dailyRate > 0 && (
                                    <h1 className="font-semibold text-base">
                                      ₹{spot.dailyRate}/ day
                                    </h1>
                                  )}
                                </div>
                                <RegularButton
                                  className="rounded-full md:text:sm lg:text-sm font-medium mt-6 px-10 "
                                  title="Book Now"
                                  onClick={() => {
                                    navigate("/profile/Booking-detail", {
                                      state: {
                                        selectedParking: spot,
                                        checkOut: endDate ? endDate : null,
                                        checkIn: startDate ? startDate : null,
                                      },
                                    });
                                  }}
                                />
                              </CardContent>
                            </Card>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div> 
          <div id="Feature"></div> */}
          {/**data.length === 0 ? null : (
            <div className="py-10 mx-[5%] ">
              <div className="text-center ">
                <h1 className=" md:text-[48px] text-[30px] font-medium text-[#2D3748] grid-cols-4">
                  We are everywhere!
                </h1>
                <h6 className="text-[#5A616B] font-normal md:text-[24px] text-[20px] my-5">
                  Find a new home for your car.
                </h6>
              </div>
              {data.length === 0 && (
                <div className="text-center">
                  <h5 className="md:text-xl text-lg font-medium text-[#2D3748] grid-cols-4 ">
                    This service is currently operational in Chicago, Austin and
                    San Francisco only. Coming to your city soon!
                  </h5>
                </div>
              )}
              <div className="mt-10 container  w-full">
                <div className="lg:flex sm:flex-row justify-center gap-10 items-center ">
                  {data &&
                    data.map((parkingType: any, index: any) => (
                      <Card
                        sx={{
                          width: "full",
                          height: "full",
                          borderRadius: "10px",
                          border: "1px solid #e6e6e6",
                          boxShadow: "none",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                          marginTop: "8px",
                        }}
                        key={index}
                      >
                        <CardMedia
                          component="img"
                          height="100%"
                          width="100%"
                          sx={{
                            height: 200,
                            width: 700,
                          }}
                          image={parkingType?.imageUrl}
                          alt="parking"
                        />
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                            padding: "0",
                            margin: "0",
                            borderRadius: "0",
                            border: "0",
                          }}
                        >
                          <Tooltip
                            title={parkingType.typeName}
                            placement="bottom-end"
                            className="text-center"
                          >
                            <h2
                              className={`text-[#2D3748]  mx-2 lg:text-[22px] md:text-[1.0rem] text-[0.5rem] font-semibold mt-5  truncate w-[12rem] 
                              `}
                            >
                              {parkingType.typeName}
                            </h2>
                          </Tooltip>

                          <h2 className="text-[#2D3748] mx-2 lg:text-[16px] md:text-[1.0rem] text-[0.9rem] font-semibold">
                            {parkingType.discountType !== "DTND" ? (
                              parkingType.discountType === "DTPRCNT" ? (
                                `${parkingType.discountOffer}% Discount`
                              ) : (
                                `₹${parkingType.discountOffer} Off`
                              )
                            ) : parkingType.discountTypeName ==
                              "No Discount" ? (
                              <p>&nbsp;</p>
                            ) : (
                              parkingType.discountTypeName
                            )}
                          </h2>
                          <RegularButton
                            className="rounded-full md:text:sm lg:text-sm font-medium mt-6 px-[24px] py-[16px] "
                            title="Find a Parking"
                            onClick={() => {
                              navigate("/profile/find-parking-slot", {
                                state: {
                                  address: address,
                                  parkingTypeId: parkingType.id,
                                  checkOut: endDate,
                                  checkIn: startDate,
                                },
                              });
                            }}
                          />
                        </CardContent>
                      </Card>
                    ))}
                </div>
              </div>
            </div>
          )*/}
          {/** Popular cities */}

          {/**<div className="w-full px-4 py-8">
            <div className="text-center" id="popular-cities">
              <h1 className="lg:text-[3rem] md:text[2.5rem] text-[30px] font-medium text-[#2D3748] mt-5 mb-8">
                Popular Cities
              </h1>
            </div>
            <Swiper
              navigation={true}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 30 },
                1024: { slidesPerView: 4, spaceBetween: 40 },
              }}
              modules={[Navigation]}
              className="mySwiper"
              onReachEnd={handleEndReach}
            >
              {popularCities.map((city) => (
                <SwiperSlide key={city.id}>
                  <div className="p-2 relative">
                    <div
                      className="relative w-full h-64 cursor-pointer"
                      onClick={() => {
                        navigate('/cities', {
                          state: {
                            cityId: city.id,
                            cityImageUrl: city.imageUrl,
                            cityName: city.name,
                            checkOut: endDate,
                            checkIn: startDate,
                            TripType: selectedTripOption,
                            selectedTZOptions: selectedTZOptions,
                          },
                        });
                        dispatch(setFromLocation(city.name));
                      }}
                    >
                      <img
                        src={city.imageUrl}
                        alt={city.name}
                        className="w-full h-full object-cover rounded-lg shadow-lg"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center">
                        <p className="text-white text-xl font-bold">{city.name}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
          {/** Testimonials
         <div className="w-full px-4 py-8">
            <div className="text-center" id="testimonials-section">
              <h1 className="lg:text-[3rem] md:text-[2.5rem] text-[30px] font-medium text-[#2D3748] mt-5 mb-8">
                Testimonials
              </h1>
            </div>

            <Swiper
              navigation={true}
              spaceBetween={10}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 30 },
                1024: { slidesPerView: 4, spaceBetween: 20 },
              }}
              modules={[Navigation]}
              className="mySwiper"
            >
              {feedbacks.map((feedback, index) => {
                const customerName = feedback?.customerObj?.name || "Anonymous";
                const avatarLetter = customerName.charAt(0).toUpperCase();
                return (
                  <SwiperSlide key={index}>
                    <div className="p-2 relative flex" style={{ height: maxHeight }}>
                      <div className="bg-white shadow-lg rounded-lg p-4 flex flex-col w-full h-full">
                        <div className="flex items-center gap-3">
                          {feedback?.customerObj?.preSignedImageUrl ? (
                            <img
                              src={feedback?.customerObj?.preSignedImageUrl}
                              alt={customerName}
                              className="w-12 h-12 rounded-full object-cover"
                            />
                          ) : (
                            <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-700 font-bold text-lg">
                              {avatarLetter}
                            </div>
                          )}
                          <div>
                            <div className="text-gray-900 font-bold">{customerName}</div>
                            <div className="flex gap-1 mt-1">
                              {Array.from({ length: 5 }).map((_, starIndex) => (
                                <span
                                  key={starIndex}
                                  style={{ color: feedback.rating > starIndex ? "gold" : "#ccc" }}
                                >
                                  ★
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                        <p className="text-gray-600 italic mt-4 flex-grow">
                          "{feedback.comments || "No comments provided"}"
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div> */}
          {/** <div
            className=" mt-10 px-4   lg:mb-5 mb-0 text-white"
            style={{
              backgroundSize: "cover",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
            id="benefits"
          >
            <div className="text-center justify-center ">
              <h1 className=" lg:text-[36px] md:text[30px] text-[24px] font-bold  text-black grid-cols-4 my-5 ">
                Benefits
              </h1>
              <div className="mt-5 place-content-center flex  w-full ">
                <div className=" lg:flex lg:flex-row flex-col flex place-content-center items-center lg:gap-36 gap-7 ">
                  {benefits.map((item, index) => (
                    <Card
                      sx={{
                        width: "100%",
                        height: "372px",
                        borderRadius: "16px",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        maxWidth: 346,
                      }}
                      key={index + item.id}
                    >
                      <CardContent>
                        <p className="flex  justify-center">{item.icon}</p>
                        <h6 className="mt-5  items-center font-bold text-2xl">
                          {item.title}
                        </h6>
                        <h6 className="mt-5 w-auto font-normal text-[16px] mx-auto items-center">
                          {item.subTitle}
                        </h6>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </div>
            </div>
          </div> 

          {airports.length === 0 ? null : (
            <div className="py-10 mx-[5%]">
              <div className="text-center">
                <h1 className="lg:text-[3rem] md:text[2.5rem] text-[30px] font-medium text-[#2D3748] grid-cols-4 my-5">
                  Airport Parking
                </h1>
              </div>
              <div className="mt-5 container mx-auto w-full">
                <div className="lg:flex sm:flex-row justify-center gap-10 items-center">
                  {airports.map((airport: any, index: any) => (
                    <Card
                      sx={{
                        width: "w-full",
                        height: "h-full",
                        borderRadius: "10px",
                        border: "1px solid #e6e6e6",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        marginTop: "8px",
                      }}
                      key={index}
                    >
                      <CardMedia
                        component="img"
                        height="100%"
                        width="100%"
                        sx={{
                          height: 200,
                          width: 700,
                        }}
                        image={
                          airport?.imageList &&
                          airport?.imageList[0].filePreSignedUrl
                        }
                        alt="parking"
                      />
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                          padding: "0",
                          margin: "0",
                          borderRadius: "0",
                          border: "0",
                        }}
                      >
                        <Tooltip
                          title={airport.name}
                          placement="bottom-end"
                          className="text-center "
                        >
                          <h2
                            className={`text-[#2D3748] mx-2 lg:text-[22px] md:text-[1.4rem] text-[1.0rem] font-semibold  mt-5 ${airports.length > 2 ? "truncate w-[14rem]" : ""
                              }`}
                          >
                            {airport.name}
                          </h2>
                        </Tooltip>
                        <div
                          title={airport.listingDescription}
                          className="text-[#667085] mx-2 font-normal text-center  truncate w-[14rem] mt-5"
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: airport.listingDescription.substring(
                                0,
                                40
                              ),
                            }}
                          />
                        </div>
                        <RegularButton
                          className="rounded-full  md:text:sm lg:text-sm font-medium mt-6 px-[40px] py-[16px] "
                          title="Book Now"
                          onClick={() => {
                            navigate("/profile/Booking-detail", {
                              state: {
                                selectedParking: airport,
                                checkOut: endDate ? endDate : null,
                                checkIn: startDate ? startDate : null,
                              },
                            });
                          }}
                        />
                      </CardContent>
                    </Card>
                  ))}
                </div>
              </div>
            </div>
          )}

          {blog.length === 0 ? null : (
            <div
              className="py-10 mx-[5%]"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
              id="latest-news"
            >
              <div className="text-center">
                <h1 className="lg:text-[3rem] md:text[2.5rem] text-[30px] font-medium text-[#2D3748] grid-cols-4 mt-5 mb-8">
                  Interesting Reads!
                </h1>
              </div>
              <div className="flex justify-between w-full items-center my-2">
                <div className="flex items-center">
                  <h1 className="md:text-2xl text-xl font-medium text-[#2D3748]">
                    New articles
                  </h1>
                </div>
                <div
                  className="flex items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/view-all-detail ");
                  }}
                >
                  <h1 className="text-md underline font-medium text-red-500 underline-offset-1">
                    View All
                  </h1>
                </div>
              </div>
              <div
                className="mt-5 container mx-auto"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="mt-5 container mx-auto w-full">
                  <div className="lg:flex sm:flex-row justify-center gap-10 ">
                    {blog.map((post: any, index: any) => (
                      <Card
                        sx={{
                          width: "w-full",
                          height: "450px",
                          borderRadius: "10px",
                          border: "1px solid #e6e6e6",
                          boxShadow: "none",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                          marginTop: "8px",
                        }}
                        key={index}
                        onClick={() => {
                          navigate("/find-blog", {
                            state: {
                              image: post.imageUrl,
                              title: post.title,
                              description: post.description,
                              id: post.id,
                            },
                          });
                        }}
                      >
                        <CardMedia
                          component="img"
                          height="100%"
                          width="100%"
                          sx={{
                            height: 200,
                            width: 1100,
                          }}
                          image={post.imageUrl}
                          alt="parking"
                        />
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            height: "100%",
                            width: "100%",
                            padding: "0",
                            margin: "0",
                            borderRadius: "0",
                            border: "0",
                          }}
                        >
                          <Tooltip
                            title={post.title}
                            placement="bottom-end"
                            className=" text-left"
                          >
                            <h2 className="text-[#2D3748] mx-2 lg:text-[22px] md:text-[1.4rem] text-[1.0rem] font-semibold truncate  w-[300px] mt-5">
                              {post.title}
                            </h2>
                          </Tooltip>
                          <h1 className="text-[#667085] mx-2 font-normal w-100%  mt-5">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: post.description.slice(0, 140),
                              }}
                            />
                            {post.description.length > 50 ? (
                              <span
                                onClick={() => {
                                  navigate("/find-blog", {
                                    state: {
                                      image: post.imageUrl,
                                      title: post.title,
                                      description: post.description,
                                      id: post.id,
                                    },
                                  });
                                }}
                                className="text-red-500"
                              >
                                {"Read More >>"}
                              </span>
                            ) : (
                              ""
                            )}
                          </h1>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </div>

        {/* {howItWorks.length === 0 ? null : (
          <div
            className="py-16 lg:px-5 px-0"
            id="how-it-works"
            style={{ backgroundColor: "#F5F7F7" }}
          >
            <div className="text-center">
              <h1 className="lg:text-[36px] md:text[30px] text-[24px] font-bold text-black grid-cols-4 ">
                How it works
              </h1>
            </div>
            <div className="container w-full relative  bottom-[-170px]">
              <div className="lg:flex sm:flex-row justify-center gap-7 lg:gap-14 xl:gap-48 items-center mt-[-150px]">
                {howItWorks &&
                  howItWorks.map((item: any, index: number) => (
                    <Card
                      sx={{
                        width: "full",
                        height: "full",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        marginTop: "8px",
                      }}
                      key={index + item.id}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                          padding: "0",
                          margin: "0",
                          borderRadius: "0",
                          border: "0",
                        }}
                      >
                        <h6 className="mt-7 flex justify-center">
                          {item.icon}
                        </h6>
                        <h6 className="mt-10 items-center font-bold text-xl">
                          {item.title}
                        </h6>
                        <h6 className="w-auto mx-auto items-center mt-5">
                          {item.image}
                        </h6>
                      </CardContent>
                    </Card>
                  ))}
              </div>
            </div>
          </div>
        )} */}

        {/**  <div
          className="h-[1080px] md:h-[1050px] lg:h-[700px] xl:h-[800px]"
          style={{
            display: "flex",
            flexDirection: "column",
            background: `url(${require("../../assets/SF-IN/becomeAPartner.png")}) center center repeat`,
            backgroundColor: "#60869e",
          }}
        >
          <div
            className="mt-8 md:mt-0 pt-20 md:pt-6 xl:pt-56 lg:pt-36 pb-10 md:pb-0"
            style={{
              backgroundSize: "cover",
              objectFit: "contain",
              backgroundPosition: "center",
              width: "100%",
              height: "800px",
              display: "flex",
              flexDirection: "column",
            }}
            id="become-a-partner"
          >
            {isAlertVisible && (
              <div className="px-24">
                <MuiAlert
                  severity={statusCodes?.type!}
                  messageType={statusCodes?.code!}
                />
              </div>
            )}

            <div className="flex lg:flex-row flex-col lg:gap-24 gap-10 lg:w-full justify-center lg:justify-items-start justify-items-center lg:p-0 md:p-24 lg:px-32 xl:px-0">
              <div className={`flex flex-col px-14 md:px-32 lg:px-0 ${isVisible ? "lg:justify-start xl:mr-56" : "justify-center items-center"}`}>
                <div className="flex flex-col lg:justify-start justify-center ">
                  <h1 className=" md:text-[36px] font-bold text-white grid-cols-4 md:mb-4 mb-2 text-[25px]">
                    Become a Partner
                  </h1>
                  <h1 className="text-white text-[12px] md:text-[16px] mb-10 font-normal">
                    Grow your business by listing your service with us.
                  </h1>
                </div>
                <div className=" flex flex-row border-b font-normal xl:text-[24px] lg:text-[20px] text-[15px]">
                  <BsGraphUpArrow className="mr-5" color="white" />
                  <h1 className="text-white mb-5 w-64 ">Grow your Business</h1>
                  <hr />
                </div>
                <div className="flex flex-row mt-5 border-b font-normal  xl:text-[24px] lg:text-[20px]  text-[15px]">
                  <MdOutlinePermContactCalendar
                    className="mr-5"
                    color="white"
                  />
                  <h1 className="text-white mb-5 w-64">Get New Customers</h1>
                </div>
                <div className="flex flex-row mt-5 border-b font-normal">
                  <BiDollarCircle
                    className="mr-5 lg:text-[30px] text-[24px]"
                    color="white"
                  />
                  <h1 className="text-white  xl:text-[24px] lg:text-[20px] text-[15px] mb-5 w-64">
                    Increase Revenue
                  </h1>
                </div>
                <h1 onClick={handleToggleVisibility} className="text-white xl:text-[18px] cursor-pointer text-blue-500 mt-5 underline">
                  Click Here to Register as a Partner Today!
                </h1>
              </div>
              <div className={`flex lg:justify-start justify-center ${isVisible ? "block" : "hidden"}`}>
                <Formik
                  validationSchema={becomeAPartnerSchema}
                  initialValues={formValues}
                  onSubmit={saveServiceProviderDataToServer}
                >
                  {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    handleReset,
                    values,
                    touched,
                    errors,
                  }) => (

                    <div>
                      <div className="flex flex-col mt-3 gap-1">
                        <label className=" text-white font-normal text-[20px]">
                          Name
                        </label>
                        <TextField
                          variant="outlined"
                          size="small"
                          type="text"
                          id={"name"}
                          name={"name"}
                          value={values.name}
                          onChange={handleChange}
                          placeholder="Enter name"
                          onBlur={handleBlur}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "2px",
                          }}
                          className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b font-bold "
                        />
                        <div className="text-[#E23744] text-sm">
                          {errors.name}
                        </div>
                      </div>
                      <div className="flex flex-col mt-3 gap-1">
                        <label className="justify-start text-white font-normal text-[20px]">
                          Business Name
                        </label>
                        <TextField
                          variant="outlined"
                          size="small"
                          id={"businessName"}
                          name={"businessName"}
                          value={values.businessName}
                          onChange={handleChange}
                          placeholder="Enter business name"
                          onBlur={handleBlur}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "2px",
                          }}
                          className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b font-bold "
                        />
                        <div className="text-[#E23744] text-sm">
                          {errors.businessName}
                        </div>
                      </div>
                      <div className="flex flex-col mt-3 gap-1">
                        <label className=" justify-start text-white font-normal text-[20px]">
                          Contact Number
                        </label>
                        <TextField
                          variant="outlined"
                          size="small"
                          id={"contactNumber"}
                          name={"contactNumber"}
                          value={values.contactNumber}
                          onChange={handleChange}
                          placeholder="Enter contact number"
                          onBlur={handleBlur}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "2px",
                          }}
                          className="appearance-none rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-b font-bold"
                        />
                        <div className="text-[#E23744] text-sm">
                          {errors.contactNumber}
                        </div>
                      </div>
                      <div className="flex flex-col mt-3 gap-1">
                        <label className="text-white font-normal text-[20px]">
                          Email ID
                        </label>
                        <TextField
                          variant="outlined"
                          size="small"
                          id={"emailId"}
                          name={"emailId"}
                          type="email"
                          value={values.emailId}
                          onChange={handleChange}
                          placeholder="Enter email id"
                          onBlur={handleBlur}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "2px",
                          }}
                          className="appearance-none rounded w-full p-2  leading-tight focus:outline-none focus:shadow-outline border-b font-bold"
                        />
                        <div className="text-[#E23744] text-sm">
                          {errors.emailId}
                        </div>
                      </div>
                      <div className="lg:flex sm:flex-row md:items-end gap-5 mt-5 lg:ml-[98px] ml-[58px] md:ml-0">
                        <button
                          className="h-14 md:w-[150px] w-[60%] bg-transparent rounded text-white p-3 font-bold text-[20px]"
                          onClick={() => {
                            handleReset();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="h-[52px] md:w-[180px] w-[60%] bg-red-500 border-2 border-white-500/100 rounded text-white font-bold text-[20px]"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
